export enum CompanyNameQuestion {
  Name = "ACN_COMPANY_NAME",
}
